export default __webpack_public_path__ + "static/media/s3-003.8914a664.png";